<template>
  <div
    v-if="value.length"
    class="entity-list__items"
  >
    <slot name="list-item">
      <div
        v-for="(val, idx) in value"
        :key="idx"
        class="entity-list__item"
      >
        <div class="entity-list__item-label">
          <template v-if="context.slots['list-item-label']">
            <component
              v-if="context.slots['list-item-label']"
              :is="context.slots['list-item-label']"
              :value="val"
            />
          </template>
          <template v-else>
            <p v-html="val.label" />
          </template>
        </div>
        <div class="entity-list__item-actions">
          <app-dropdown
            placement="bottom-end"
            content-class="min-w-36"
            :ref="(el) => (dropdownRefs[idx] = el)"
          >
            <button
              type="button"
              class="entity-list__item-action"
            >
              <app-icon name="dots-vertical" />
            </button>
            <template #content>
              <list-group>
                <list-item
                  class="rounded-none"
                  @click="() => onEdit(val)"
                >
                  <template #prefix>
                    <app-icon
                      name="edit"
                      size="sm"
                    />
                  </template>
                  Edit entry
                </list-item>
                <list-item
                  v-if="context.canCopy"
                  class="rounded-none"
                  @click="() => handleCopy(val, idx)"
                >
                  <template #prefix>
                    <app-icon
                      name="copy"
                      size="sm"
                    />
                  </template>
                  Copy to clipboard
                </list-item>
                <hr class="border-t border-gray-200" />
                <list-item
                  class="rounded-none"
                  @click="() => handleDelete(idx)"
                >
                  <template #prefix>
                    <app-icon
                      name="trash"
                      size="sm"
                    />
                  </template>
                  Delete
                </list-item>
              </list-group>
            </template>
          </app-dropdown>
        </div>
      </div>
    </slot>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ListGroup from '@/components/ui/list/ListGroup.vue';
import ListItem from '@/components/ui/list/ListItem.vue';

const dropdownRefs = ref([]);

const props = defineProps({
  context: Object,
  value: {
    type: Array,
    required: true,
  },
  onEdit: {
    type: Function,
    required: true,
  },
  onDelete: {
    type: Function,
    required: true,
  },
});

const handleCopy = (val, idx) => {
  navigator.clipboard.writeText(val.value);
  closeDropdown(idx);
};

const handleDelete = (idx) => {
  props.onDelete(idx);
  closeDropdown(idx);
};

const closeDropdown = (idx) => {
  dropdownRefs.value[idx].close();
};
</script>

<style>
@reference '@/assets/main.css';

.entity-list__items {
  @apply w-[calc(100%+3rem)] -mx-3 -my-1 divide-y divide-gray-200 border-t border-gray-200;
}

.entity-list__item {
  @apply flex items-center justify-between p-3;
}

.entity-list__item-label {
  @apply flex items-center gap-2;
}

.entity-list__item-action {
  @apply btn btn-square btn-ghost btn-sm;
}
</style>
